var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatePicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8889 1.9H15.8333V0H13.7222V1.9H5.27778V0H3.16667V1.9H2.11111C0.939444 1.9 0 2.755 0 3.8V17.1C0 18.145 0.939444 19 2.11111 19H16.8889C18.05 19 19 18.145 19 17.1V3.8C19 2.755 18.05 1.9 16.8889 1.9ZM16.8889 17.1H2.11111V6.65H16.8889V17.1ZM3.69444 10.45C3.69444 9.139 4.87667 8.075 6.33333 8.075C7.79 8.075 8.97222 9.139 8.97222 10.45C8.97222 11.761 7.79 12.825 6.33333 12.825C4.87667 12.825 3.69444 11.761 3.69444 10.45Z",
    fill: "#525C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePicker);
export default __webpack_public_path__ + "static/media/datePicker.6e8a1d2dc7b2acfe2f07701310e5b4a8.svg";
export { ForwardRef as ReactComponent };